import React, { useContext, useEffect } from "react";
import { MessagesContext } from "../context/messagesContext";

import MessageSection from "../components/MessageSection";
import FindObject from "../components/FindObject";
import WorkspaceDisplay from "../components/WorkspaceDisplay";
import Loading from "../components/Loading";

const Messages = ({ message, initSearch }) => {
  const { setMessage, isWorkspaceLoading } = useContext(MessagesContext);

  useEffect(() => {
    setMessage(message);
  }, []);

  return (
    <div>
      <MessageSection message={message} />
      <FindObject initSearch={initSearch} />
      <WorkspaceDisplay />
      <Loading isLoading={isWorkspaceLoading} />
    </div>
  );
};

export default Messages;
